'use client'
import {lazy, Suspense} from 'react';
import AuthDropdown from "@/components/auth/auth-dropdown";
import {authClient} from "@/lib/auth-client";
import {Button} from "@/shadcn/components/ui/button";
import {UserRound} from "lucide-react";
import {useEffect, useState} from "react";

const AuthenticationSheet = lazy(() => import("@/components/auth/authentication-sheet"));

// Placeholder button that matches real button dimensions - prevents CLS
const AuthButtonPlaceholder = () => (
    <div role='button'>
        <Button
            aria-label={'Anmelden'}
            variant={'outline'}
            size={'icon'}
            disabled
            className="sm:hidden relative -mt-4 flex-col items-center justify-center focus:ring-0 lg:flex-row gap-0.5 lg:gap-2 opacity-50">
            <UserRound className={"h-5 w-5"}/>
            <span className={"absolute mt-14 text-[0.65rem]"}>Anmelden</span>
        </Button>
        <Button
            aria-label={'Anmelden'}
            variant={'outline'}
            size={'sm'}
            disabled
            className="hidden sm:flex relative items-center justify-center focus:ring-0 lg:flex-row gap-0.5 lg:gap-2 opacity-50">
            <UserRound className={"h-4 w-4"}/>
            <span className={"sm:text-xs lg:text-sm"}>Anmelden</span>
        </Button>
    </div>
);

export const AuthenticationButton = () => {
    const [isMounted, setIsMounted] = useState(false);
    const {data, isPending} = authClient.useSession();

    useEffect(() => {
        setIsMounted(true);
    }, []);

    // Show placeholder during SSR and initial hydration to prevent CLS
    if (!isMounted || isPending) {
        return <AuthButtonPlaceholder/>;
    }

    return <>
        {!data && (
            <Suspense fallback={<AuthButtonPlaceholder/>}>
                <AuthenticationSheet/>
            </Suspense>
        )}
        {data && <AuthDropdown/>}
    </>;
}

export default AuthenticationButton;
